import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import VueTheMask from 'vue-the-mask'
import router from './router/index'
import '@fortawesome/fontawesome-free/css/all.css'
import './registerServiceWorker'
import { formatDate, formatNumber } from './helpers'
import { watchEffect } from 'vue'
import { i18n } from './i18n'

watchEffect(() => {
  const t = i18n.global.t
  document.title = t('meta.title')

  const rawLang =
    typeof i18n.global.locale === 'string'
      ? i18n.global.locale
      : i18n.global.locale.value
  let lang = rawLang.toLowerCase()

  if (lang === 'kg') {
    lang = 'ky-KG'
  }

  if (lang === 'ru') {
    lang = 'ru-KG'
  }

  document.documentElement.setAttribute('lang', lang)
})

loadFonts()

const app = createApp(App).use(i18n);

app.config.globalProperties.$formatNumber = formatNumber;
app.config.globalProperties.$formatDate = formatDate;

app
  .use(vuetify)
  .use(VueTheMask)
  .use(router)
  .mount('#app');
